<template>
    <PlotCard
        :data="plot"
        :screenProperties="screenProperties"
        :type="type"
        :width="type !== 'plot-grid' ? cardWidth : '100%'"
        @update-widget="updateWidget"
    />
</template>

<script>
    import PlotCard from "@/components/plotInformation/PlotCard";

    export default {
        name: 'PlotGridCard',
        components: {
            PlotCard
        },
        props: {
            plot: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },
        computed: {
            screenProperties() {
                return {
                    'isTinyScreen': window.matchMedia("(orientation: portrait)").matches ? (this.$vuetify.breakpoint.width < 375 && this.$vuetify.breakpoint.height < 667 ? true : false) : (this.$vuetify.breakpoint.width < 667 && this.$vuetify.breakpoint.height < 375 ? true : false),
                    'isSmallScreen': this.$vuetify.breakpoint.smAndDown,
                    'isMediumScreen': this.$vuetify.breakpoint.smAndUp && this.$vuetify.breakpoint.mdAndDown ? true : false,
                    'isLargeScreen': this.$vuetify.breakpoint.lgAndUp,
                    'isPortrait': window.matchMedia("(orientation: portrait)").matches,
                    'isLandscape': window.matchMedia("(orientation: landscape)").matches
                };
            },
            cardWidth() {
                return this.screenProperties.isPortrait ? 280 : 500;
            }
        },
        methods: {
            updateWidget(plot) {
                this.$emit('update-widget', plot);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/plotGrid/PlotGridCard.vue